import { Outlet, NavLink, Navigate, Link } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import {
  LayoutDashboard,
  Users,
  Package,
  ArrowLeft,
  Search,
  MessageCircle,
  Bell,
  FileBarChart,
} from "lucide-react";
import "./Admin.css";

export default function AdminLayout() {
  const { isAdmin, loading } = useAuth();
  if (loading)
    return (
      <div className="loading-center">
        <div className="spinner spinner-lg" />
      </div>
    );
  if (!isAdmin) return <Navigate to="/app/dashboard" replace />;

  return (
    <div className="admin-shell">
      <aside className="admin-sidebar">
        <div className="admin-sidebar-top">
          <div className="admin-brand">
            <div className="admin-brand-icon">A</div>
            <div>
              <div className="admin-brand-title">Admin Portal</div>
              <div className="admin-brand-sub">GLA Exchange</div>
            </div>
          </div>

          <nav className="admin-nav">
            <NavLink
              to="/admin"
              end
              className={({ isActive }) =>
                "admin-nav-link " + (isActive ? "active" : "")
              }
            >
              <LayoutDashboard size={17} /> Dashboard
            </NavLink>
            <NavLink
              to="/admin/users"
              className={({ isActive }) =>
                "admin-nav-link " + (isActive ? "active" : "")
              }
            >
              <Users size={17} /> Users
            </NavLink>
            <NavLink
              to="/admin/products"
              className={({ isActive }) =>
                "admin-nav-link " + (isActive ? "active" : "")
              }
            >
              <Package size={17} /> Products
            </NavLink>
            <NavLink
              to="/admin/lostfound"
              className={({ isActive }) =>
                "admin-nav-link " + (isActive ? "active" : "")
              }
            >
              <Search size={17} /> Lost &amp; Found
            </NavLink>
            <NavLink
              to="/admin/chat"
              className={({ isActive }) =>
                "admin-nav-link " + (isActive ? "active" : "")
              }
            >
              <MessageCircle size={17} /> Chat Monitor
            </NavLink>
            <NavLink
              to="/admin/notifications"
              className={({ isActive }) =>
                "admin-nav-link " + (isActive ? "active" : "")
              }
            >
              <Bell size={17} /> Notifications
            </NavLink>
            <NavLink
              to="/admin/reports"
              className={({ isActive }) =>
                "admin-nav-link " + (isActive ? "active" : "")
              }
            >
              <FileBarChart size={17} /> Reports
            </NavLink>
          </nav>
        </div>

        <Link to="/app/dashboard" className="admin-back-link">
          <ArrowLeft size={15} /> Back to App
        </Link>
      </aside>

      <main className="admin-main">
        <div className="admin-content">
          <Outlet />
        </div>
      </main>
    </div>
  );
}